<template>
	<TheTable
		v-if="tableData"
		:tableData="tableData"
		:loading="loading"
		:defaultSort="{ prop: 'createdDate', order: 'descending' }"
		:showMaxRows="4"
		@rowClick="openDetail"
	>
		<el-table-column prop="" label="Beantwortet" width="130" sortable>
			<template #default="scope">
				<span v-if="scope.row.answer">Ja</span>
				<span v-else>Nein</span>
			</template>
		</el-table-column>

		<el-table-column prop="" label="Datum" width="100" sortable>
			<template #default="scope">
				<span>{{ $formatDate(scope.row.createdDate) }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="text" label="Rückfrage" min-width="150" sortable />
		<el-table-column prop="validToDate" label="RF bis" width="100" sortable>
			<template #default="scope">
				<span>{{ $formatDate(scope.row.validToDate) }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="answer" label="Antwort" min-width="150" sortable :class-name="'cell--alignleft'" />
	</TheTable>

	<TablePagination :currentLength="tableData.length" :totalMaxVal="totalCount" @loadNextPage="$emit('loadNextPage')" />
	<DialogCallbackDetail v-model:open="openDetailDialog" :callbackObject="detailCallbackObject" @close="closeDetail" />
</template>

<script lang="ts">
import TheTable from '../TheTable.vue';
import TablePagination from './TablePagination.vue';
import DialogCallbackDetail from '../dialogs/DialogCallbackDetail.vue';
import { CallbackResponse } from '../../types/types';

import { useStore } from '@/store';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
	name: 'CallbacksTable',
	data() {
		return {
			openDetailDialog: false,
			detailCallbackObject: null as CallbackResponse | null,
		};
	},
	setup() {
		const store = useStore();

		return {
			store,
		};
	},
	props: {
		tableData: {
			type: Array as PropType<CallbackResponse[]>,
			default: [],
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		totalCount: {
			type: Number,
			default: 0,
		},
	},
	emits: ['loadNextPage'],
	components: {
		TheTable,
		TablePagination,
		DialogCallbackDetail,
	},
	computed: {},
	methods: {
		openDetail(row: CallbackResponse) {
			this.openDetailDialog = true;
			this.detailCallbackObject = row;
		},
		closeDetail() {
			this.openDetailDialog = false;
			this.detailCallbackObject = null;
		},
	},
});
</script>

<style lang="scss"></style>
